import { NgModule } from '@angular/core';
import { ToastComponent } from './layouts';
import { AppComponent } from './app.component';
import { DxLoadPanelModule } from 'devextreme-angular';
import { ProviderList } from './app-provider-registrar';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';
import { NgbToastModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: '#a79ef3',
  bgsOpacity: 0.5,
  bgsPosition: 'center-center',
  bgsSize: 70,
  bgsType: 'three-strings',
  fgsColor: '#a79ef3',
  fgsPosition: 'center-center',
  fgsSize: 70,
  fgsType: 'three-strings',
  hasProgressBar: false,
};

@NgModule({
  declarations: [
    AppComponent,
    ToastComponent
  ],

  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    NgbToastModule,
    DxLoadPanelModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgbModule
  ],

  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    ...ProviderList
  ],

  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private router: Router, private titleService: Title, private route: ActivatedRoute) {
    router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        var title = 'KISNA-POS';
        this.titleService.setTitle(title);
      }
    });
  }
}